export const getBoolEnv = (e: string | undefined): boolean => e === 'true';
